import styles from "~/sass/organisms/Article/Article.module.scss";
import Head from "~/components/Meta/Head";
import ArticleAuthor from "~/components/molecules/Article/ArticleAuthor.js";
import Script from "next/script";

export default function Article({}) {
  const content = () => {
    return (
      <>
        <h1 className={styles["Article__heading"]}>
          European Architecture: Castle Terminology
        </h1>
        <ArticleAuthor />
        <ul>
          <li>
            <p>Abacus - the top of a capital that is flat</p>
          </li>
          <li>
            <p>
              Aisle - between the outer wall and the arcade there is a space,
              that is the aisle
            </p>
          </li>
          <li>
            <p>
              Allure - on the top of a castle wall there is a walkway, that is
              the allure
            </p>
          </li>
          <li>
            <p>
              Arcade - these are free-standing rows of arches. They are
              supported on columns
            </p>
          </li>
        </ul>
        <ul>
          <li>
            <p>
              Ashlar - blocks of smooth stone that are neatly trimmed, they are
              square-shaped
            </p>
          </li>
          <li>
            <p>
              Bailey - these are the courtyards on the inside of castle walls,
              they include several living areas and some recreation areas
            </p>
          </li>
          <li>
            <p>Balusters - columns that are small</p>
          </li>
          <li>
            <p>
              Bar holes - the holes in which the door-bolt is placed, usually
              the bolt is constructed with timber
            </p>
          </li>
          <li>
            <p>
              Batter - the portion of the curtain wall that is sloped. There is
              a rather sharp angle at the base of each wall within a tower
              positioned along the exterior surface
            </p>
          </li>
          <li>
            <p>
              Bivalate - two concentric ditches designed for defense, these are
              situated within hillforts&nbsp;
            </p>
          </li>
          <li>
            <p>
              Capital - the upper end of a column, treated in a distinct fashion
            </p>
          </li>
          <li>
            <p>
              Casemates - emplacements for an artillery, these are in separate
              and always-protected rooms
            </p>
          </li>
          <li>
            <p>
              Chamfer - the smoothing off of an angle in between two stone faces
              at the surface
            </p>
          </li>
          <li>
            <p>
              Chancel - a space that surrounds a church altar within the castle
            </p>
          </li>
          <li>
            <p>Chevron - molding that incorporates a zig-zag pattern</p>
          </li>
          <li>
            <p>
              Daub - mud comprised of a clay mixture, this is used to strengthen
              and seal the wattle
            </p>
          </li>
          <li>
            <p>Donjon - a massive tower, also known as a keep</p>
          </li>
          <li>
            <p>Dressing - the stonework around openings that is carved</p>
          </li>
          <li>
            <p>Embattled - crenelated and battlemented</p>
          </li>
          <li>
            <p>Enceinte - the fortified enclosed area of a castle&nbsp;</p>
          </li>
          <li>
            <p>
              Fascine - brushwood in a massive bundle, used to fill in ditches
              or revetting ramparts
            </p>
          </li>
          <li>
            <p>
              Finial - a slim section of stone that is utilized as decoration on
              the top of a merlon
            </p>
          </li>
          <li>
            <p>Footing - the bottom section of a wall</p>
          </li>
          <li>
            <p>Freestone - limestone or sandstone of the highest quality</p>
          </li>
          <li>
            <p>Fresco - a wet plaster wall that has been painted</p>
          </li>
          <li>
            <p>
              Garderobe - a small toilet set into the thickness of the castle
              wall, it may also project outward from the wall
            </p>
          </li>
          <li>
            <p>Great chamber - the bed-sitting room of the Lord</p>
          </li>
          <li>
            <p>Hall - a major room or building within the castle complex</p>
          </li>
          <li>
            <p>
              Hillfort - iron age or bronze earthwork, used as a defense of
              concentric ditches and banks
            </p>
          </li>
          <li>
            <p>
              Hornwork - a quadrilateral, freestanding fortification in the
              forefront of the main wall
            </p>
          </li>
          <li>
            <p>Impost - a wall bracket designed to support the arch</p>
          </li>
          <li>
            <p>Inner Curtain - a high wall which surrounds the inner ward</p>
          </li>
          <li>
            <p>
              Jamb - these are the side posts of a window, an arch, or a door
              within the castle
            </p>
          </li>
          <li>
            <p>
              Keep - an incredibly strong tower made of sturdy stone, this is
              often the main tower in a castle
            </p>
          </li>
          <li>
            <p>Lancet - a narrow and long window with a head that is pointed</p>
          </li>
          <li>
            <p>
              Mantlet - the detached fortification which prevents direct access
              to a castle's gateway
            </p>
          </li>
          <li>
            <p>Mullion - windows that are vertically divided</p>
          </li>
          <li>
            <p>Nailhead - a pyramid-shaped molding</p>
          </li>
          <li>
            <p>
              Offset - a ledge that marks the narrowing thickness of a castle
              wall
            </p>
          </li>
          <li>
            <p>
              Palisade - an extremely sturdy fence made of wood, it is meant to
              enclose a wall temporarily, eventually a permanent stone wall will
              be constructed
            </p>
          </li>
          <li>
            <p>Quadrangle - the inner courtyard</p>
          </li>
          <li>
            <p>
              Rampart - stone or earth wall constructed of defensive stone that
              surrounds a castle
            </p>
          </li>
          <li>
            <p>Refectory - a communal hall meant for dining</p>
          </li>
          <li>
            <p>
              Respond - a half-pier that is bonded into a wall. It typically
              carries an arch.
            </p>
          </li>
          <li>
            <p>Salient - an arrowhead or a wall projection</p>
          </li>
          <li>
            <p>Scarp - a slope within the inner part of a ditch</p>
          </li>
          <li>
            <p>Tau cross - a plain T cross encompassing equal limbs</p>
          </li>
          <li>
            <p>
              Wall-walk - &nbsp;a passage that is situated along the castle wall
            </p>
          </li>
          <li>
            <p>
              Weathering - a surface that is sloped, created to disperse
              rainwater
            </p>
          </li>
          <li>
            <p>Yett - A gate made from iron lattice</p>
          </li>
        </ul>
        <h2 className={styles["Article__sub-heading"]}>
          Additional Information on Castles
        </h2>
        <ul>
          <li>
            <p>
              <a href="https://www.nationalarchives.gov.uk/education/resources/medieval-castles/">
                Medieval Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://whc.unesco.org/en/list/288/">
                Castles of Augustusburg and Falkenlust at Bruhl
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.michigan.org/article/trip-idea/magnificent-castles-michigan">
                7 Magnificent Castles in Michigan Fit for a Royal Trip
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="http://www.primaryhomeworkhelp.co.uk/Castles.html">
                All About Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://cadw.gov.wales/visit/places-to-visit/castles-wales">
                Castles of Wales
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://staff.4j.lane.edu/~superneau_a/Superneau%207th%20Grade%20Social%20Studies/Castle%20Project/Medieval%20Castles.pdf">
                Group Design Challenge - Medieval Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.worldhistory.org/Medieval_Castle/">
                Medieval Castle - World History Encyclopedia
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.english-heritage.org.uk/siteassets/home/learn/teaching-resources/1066-design-your-own-norman-castle_pevensey-castle-teachers-kit_ks3-4.pdf">
                Design Your Own Norman Castle
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="http://rubens.anu.edu.au/raid1/student_projects97/castles/building/page.html">
                Castle Building Techniques and Designs
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://readings.design/PDF/castles-made-of-sand.pdf">
                Castles Made of Sand
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://localhistories.org/a-history-of-castles/">
                A History of Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.historic-uk.com/HistoryMagazine/DestinationsUK/History-of-Castles/">
                The History of Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.castlesandmanorhouses.com/types_02_international.htm">
                Types of Castles and the History of Castles Around the World
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://englishhistory.net/middle-ages/medieval-castles/">
                English History - Medieval Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://artuk.org/discover/curations/castles-in-reality-history-and-myth">
                Castles in Reality, History and Myth
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.celticcastles.com/castle-blog/5-famous-world-castles/">
                5 Famous World Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.smithsonianmag.com/travel/worlds-most-visited-castles-180954081/#:~:text=1%3A%20The%20Forbidden%20City%20(Palace%20Museum)%2C%20Beijing&amp;text=Each%20day%2C%20tens%20of%20thousands,emperors%20and%20their%20extensive%20entourages.">
                The World's Most-Visited Castles and Palaces
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.prague-stay.com/lifestyle/category/92-czech-republic-attractions/93-famous-czech-castles-chateaux-and-villas">
                Famous Czech Castles, Chateaux and Villas
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.visitscotland.com/things-to-do/attractions/castles/great-scottish-castles">
                10 Great Scottish Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://allabout-japan.com/en/article/2899/">
                Japan's Three Famous Castles
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://csis.pace.edu/grendel/projs3h/castles.htm">
                Castles in the Middle Ages
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.realestateagents.com/real-estate-agents/new-castle-de">
                New Castle Real Estate
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.timeref.com/castles/why_castles_were_built.htm">
                Why Build and Live In Castles?
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.wonderopolis.org/wonder/why-did-castles-have-moats">
                Why Did Castles Have Moats?
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://etheses.whiterose.ac.uk/9826/1/369275.pdf">
                The Idea of the Castle in Medieval England
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.rct.uk/visit/windsor-castle/who-built-windsor-castle#/">
                Who Built Windsor Castle?
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://seeker.io/top-castles-america/">
                Castles in America: Discover Your Own Fairytale
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.oldest.org/structures/oldest-castles-in-america/">
                Oldest Castles in America
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.realestateagents.com/real-estate-agents/castle-rock-co">
                Castle Rock Property Agents
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.minube.net/tag/castles-central-america-sp525">
                8 Castles in Central America
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="https://www.farandwide.com/s/best-castle-every-state-4df412c00d354dd9">
                Every U.S. State Has a Castle - and These Are the Best
              </a>
            </p>
          </li>
          <li>
            <p>
              <a href="http://www.thescoutproject.org/journal/field-guide/art-and-culture/castles-in-north-america">
                5 Castles In North America and the Stories Behind Them
              </a>
            </p>
          </li>
        </ul>
      </>
    );
  };

  return (
    <>
      <Head
        title={
          "European Architecture: Castle Terminology | RealEstateAgents.com"
        }
        description={
          "Wondering how to describe your home or curious about identifying a specific element? This terminology index will expand your vocabulary!"
        }
      />
      <article className={styles["Article"]}>
        <div className={styles["Article__container"]}>{content()}</div>
      </article>
      <Script strategy="beforeInteractive" type="application/ld+json">
        {{
          "@context": "https://schema.org",
          "@type": "Article",
          mainEntityOfPage: {
            "@type": "WebPage",
            "@id":
              "https://www.realestateagents.com/articles/european-architecture-castle-terminology",
          },
          headline: "European Architecture: Castle Terminology",
          author: {
            "@type": "Person",
            name: "Amber Martinez",
            jobTitle: "Education Writer",
            sameAs: [
              "https://www.realestateagents.com/articles/author/amber-martinez",
              "https://www.linkedin.com/in/amber-martinez-7096651a/",
            ],
          },
        }}
      </Script>
    </>
  );
}
